import React from 'react';
import { useNavigate } from 'react-router-dom';

import classNames from 'classnames';

import { useOverlayState } from '../../../hooks/useOverlayState';

import { pageHorizontalPaddings } from '../PlaybookTabsView/PlaybookTabsView';

import PlaybookSharingModal from '../PlaybookSharingModal/PlaybookSharingModal';
import { Button } from '../../../design-system';
import { ArrowGoBackLineIcon } from '../../../design-system/Icons';

const TabViewsTopControls = ({
    backLinkHref,
    playbookDetail,
    setPlaybookDetail,
    playbookContentFormData,
}) => {
    const { name } = playbookDetail;

    const navigate = useNavigate();

    const { isOpened, open: openSharingModal, close: closeSharingModal } = useOverlayState();

    return (
        <div
            className={classNames(pageHorizontalPaddings, 'flex items-start justify-between gap-4')}
        >
            <div className="flex items-start gap-5">
                <Button
                    type="link"
                    size="xs"
                    text="Back"
                    leadingIcon={ArrowGoBackLineIcon}
                    onClick={() => navigate(backLinkHref)}
                />
                <div className="min-h-[36px] flex items-center">
                    <p className="font-body text-body-regular-s text-neutral-300">
                        Playbook / <span className="font-body-bold text-body-bold-s">{name}</span>
                    </p>
                </div>
            </div>

            <div>
                <Button type="neutral" size="sm" text="Share" onClick={openSharingModal} />
            </div>

            {isOpened && (
                <PlaybookSharingModal
                    playbookDetail={playbookDetail}
                    setPlaybookDetail={setPlaybookDetail}
                    playbookContentFormData={playbookContentFormData}
                    onClose={closeSharingModal}
                />
            )}
        </div>
    );
};

export default TabViewsTopControls;
